// features/public-map/application/hoverStore.ts
import { create } from 'zustand';

type HoverState = {
  // Single property hover (from individual marker or list item)
  hoveredPropertyId: string | null;
  setHoveredPropertyId: (id: string | null) => void;

  // Multiple properties (from cluster hover)
  hoveredPropertyIds: string[];
  setHoveredPropertyIds: (ids: string[]) => void;

  // Cluster-specific state
  hoveredClusterId: number | null;
  setHoveredClusterId: (id: number | null) => void;

  // Helper to check if a property is hovered
  isPropertyHovered: (propertyId: string) => boolean;

  // Helper to check if property is part of a hovered cluster
  isPropertyInHoveredCluster: (propertyId: string) => boolean;

  // Clear all hover state
  clearHover: () => void;
};

export const useHoverStore = create<HoverState>((set, get) => ({
  hoveredPropertyId: null,
  setHoveredPropertyId: (id) => set({
    hoveredPropertyId: id,
    hoveredPropertyIds: id ? [id] : [],
    hoveredClusterId: null, // Clear cluster when setting single property
  }),

  hoveredPropertyIds: [],
  setHoveredPropertyIds: (ids) => set({
    hoveredPropertyIds: ids,
    hoveredPropertyId: ids.length === 1 ? ids[0] : null,
  }),

  hoveredClusterId: null,
  setHoveredClusterId: (id) => set({ hoveredClusterId: id }),

  isPropertyHovered: (propertyId) => {
    const state = get();
    return state.hoveredPropertyId === propertyId ||
           state.hoveredPropertyIds.includes(propertyId);
  },

  isPropertyInHoveredCluster: (propertyId) => {
    const state = get();
    return state.hoveredClusterId !== null &&
           state.hoveredPropertyIds.includes(propertyId) &&
           state.hoveredPropertyId !== propertyId;
  },

  clearHover: () => set({
    hoveredPropertyId: null,
    hoveredPropertyIds: [],
    hoveredClusterId: null,
  }),
}));
